import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { USERINFO_REDUCER_KEY } from './userInfoTypes';

type State = Pick<RootState, USERINFO_REDUCER_KEY>;
export const getUserInfoStore = (state: State) => state[USERINFO_REDUCER_KEY];

export const getIsLoading = createSelector([getUserInfoStore], (store) => store.isLoading);
export const getLoadPending = createSelector([getUserInfoStore], (store) => store.loadPending);
export const getError = createSelector([getUserInfoStore], (store) => store.error);
export const getResourcesById = createSelector([getUserInfoStore], (store) => store.resourcesById);

export const getUserInfo = createSelector([getUserInfoStore], (store) => store.resourcesById.first());

export const isEntitled = createSelector(getUserInfo, (userinfo) => {
  const acmeEntitlement = userinfo?.entitlements?.find((entitlement) => entitlement.startsWith('ACME_'));
  return !!acmeEntitlement;
});

// Excludes the provisional entitlement QCS grants members of someone else's active shared space.
export const hasOwnEntitlement = createSelector(getUserInfo, (userinfo) =>
  Boolean(
    userinfo?.entitlements?.find(
      (entitlement) => entitlement.startsWith('ACME_') && entitlement !== 'ACME_PROVISIONAL',
    ),
  ),
);
